import _toConsumableArray from "/workspace/seongsudong/web/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js";
import _defineProperty from "/workspace/seongsudong/web/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
import _asyncToGenerator from "/workspace/seongsudong/web/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es6.string.sub.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _regeneratorRuntime from "/workspace/seongsudong/web/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import * as types from "./mutation_types";
import { cloneData } from 'src/_mixins/CommonMethods';
import { Loading } from 'element-ui';
export default {
  callGNB: function () {
    var _callGNB = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(context) {
      var localStorage, localGNB, localChecksum, _yield$vm$$axios$post, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            localStorage = vm.$localStorage; // localStorage.set('gnb', '')
            // localStorage.set('gnbChecksum', '')
            localGNB = localStorage.get('gnb');
            localChecksum = localStorage.get('gnbChecksum');
            if (!(localGNB && JSON.parse(localGNB).length)) {
              _context.next = 12;
              break;
            }
            context.commit(types.UPDATE_GNB, JSON.parse(localGNB));
            _context.next = 7;
            return vm.$axios.post('/post_cates/gnb/checksum', {
              checksum: localChecksum
            });
          case 7:
            _yield$vm$$axios$post = _context.sent;
            data = _yield$vm$$axios$post.data;
            if (data.changed && data.value) {
              context.commit(types.UPDATE_GNB, data.value);
              localStorage.set('gnb', JSON.stringify(data.value));
              localStorage.set('gnbChecksum', data.checksum);
            }
            _context.next = 14;
            break;
          case 12:
            _context.next = 14;
            return context.dispatch('loadGNB');
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function callGNB(_x) {
      return _callGNB.apply(this, arguments);
    }
    return callGNB;
  }(),
  loadGNB: function () {
    var _loadGNB = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(context) {
      var localStorage, _yield$vm$$axios$get, data;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return vm.$localStorage;
          case 2:
            localStorage = _context2.sent;
            _context2.next = 5;
            return vm.$axios.get('/post_cates/gnb');
          case 5:
            _yield$vm$$axios$get = _context2.sent;
            data = _yield$vm$$axios$get.data;
            if (data.value) {
              context.commit(types.UPDATE_GNB, data.value);
              localStorage.set('gnb', JSON.stringify(data.value));
              localStorage.set('gnbChecksum', data.checksum);
            }
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    function loadGNB(_x2) {
      return _loadGNB.apply(this, arguments);
    }
    return loadGNB;
  }(),
  callCategories: function callCategories(context) {
    if (context.getters.getCategoriesCnt < 1) {
      context.dispatch('loadCategories');
    }
  },
  loadCategories: function loadCategories(context) {
    vm.$axios.get('/post_cates').then(function (rs) {
      context.commit(types.UPDATE_CATEGORIES, rs.data.value);
    });
  },
  callLatestPosts: function callLatestPosts(context) {
    if (context.getters.getLatestPosts.total < 1) {
      context.dispatch('loadLatestPosts');
    }
  },
  loadLatestPosts: function loadLatestPosts(context) {
    var posts = cloneData(context.getters.getLatestPosts);
    posts.loading = true;
    context.commit(types.UPDATE_LATEST_POSTS, posts);
    var params = {
      params: {
        p: posts.page + 1,
        perPage: posts.perPage
      }
    };
    vm.$axios.get('/posts/recent', params).then(function (rs) {
      posts.loading = false;
      posts.total = rs.data.total;
      posts.page = rs.data.page;
      posts.data = posts.data.concat(rs.data.data);
      context.commit(types.UPDATE_LATEST_POSTS, posts);
    });
  },
  callChartPostsWithKey: function callChartPostsWithKey(context, forceKey) {
    if (!context.getters.getChartPostsWithKey(forceKey) || context.getters.getChartPostsWithKey(forceKey).total === 0) {
      context.dispatch('loadChartPosts', forceKey);
    }
  },
  callChartPosts: function callChartPosts(context) {
    if (!context.getters.getChartPosts || context.getters.getChartPosts.total === 0) {
      context.dispatch('loadChartPosts');
    }
  },
  loadChartPosts: function () {
    var _loadChartPosts = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(context, forceKey) {
      var _vm$$route$params$mai, _vm$$route$params$sub;
      var main, sub, key, prevPosts, params, rs, updatedPosts;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            main = (_vm$$route$params$mai = vm.$route.params.main) !== null && _vm$$route$params$mai !== void 0 ? _vm$$route$params$mai : 'trend';
            sub = (_vm$$route$params$sub = vm.$route.params.sub) !== null && _vm$$route$params$sub !== void 0 ? _vm$$route$params$sub : '';
            key = forceKey !== null && forceKey !== void 0 ? forceKey : context.getters.makeChartPostKey;
            prevPosts = context.getters.getChartPosts;
            context.commit(types.UPDATE_CHART_POSTS, {
              key: key,
              value: _objectSpread(_objectSpread({}, prevPosts), {}, {
                loading: true
              })
            });
            params = {
              params: {
                p: prevPosts.page + 1,
                perPage: prevPosts.perPage,
                chart: main
              }
            };
            if (main !== 'trend') params.params.post_cate = context.getters.getCurrentGNB.path;
            _context3.prev = 7;
            _context3.next = 10;
            return vm.$axios.get("/posts/chart", params);
          case 10:
            rs = _context3.sent;
            updatedPosts = _objectSpread(_objectSpread({}, prevPosts), {}, {
              loading: false,
              total: rs.data.total,
              page: rs.data.page,
              data: [].concat(_toConsumableArray(prevPosts.data), _toConsumableArray(rs.data.data))
            });
            context.commit(types.UPDATE_CHART_POSTS, {
              key: key,
              value: updatedPosts
            });
            _context3.next = 19;
            break;
          case 15:
            _context3.prev = 15;
            _context3.t0 = _context3["catch"](7);
            console.log('Error loading chart posts:', _context3.t0);
            context.commit(types.UPDATE_CHART_POSTS, {
              key: key,
              value: _objectSpread(_objectSpread({}, prevPosts), {}, {
                loading: false
              })
            });
          case 19:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[7, 15]]);
    }));
    function loadChartPosts(_x3, _x4) {
      return _loadChartPosts.apply(this, arguments);
    }
    return loadChartPosts;
  }(),
  callCatePosts: function callCatePosts(context) {
    if (!context.getters.getCatePosts || context.getters.getCatePosts.total === 0) {
      context.dispatch('loadCatePosts');
    }
  },
  loadCatePosts: function () {
    var _loadCatePosts = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(context) {
      var key, prevPosts, postCate, params, rs, updatedPosts;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            key = context.getters.makeCatePostKey;
            prevPosts = context.getters.getCatePosts;
            context.commit(types.UPDATE_CATE_POSTS, {
              key: key,
              value: _objectSpread(_objectSpread({}, prevPosts), {}, {
                loading: true
              })
            });
            postCate = context.getters.getCurrentGNB ? context.getters.getCurrentGNB.path : [];
            params = {
              params: {
                p: prevPosts.page + 1,
                perPage: prevPosts.perPage
              }
            };
            if (postCate) params.params.post_cate = postCate;
            _context4.prev = 6;
            _context4.next = 9;
            return vm.$axios.get('/posts/search', params);
          case 9:
            rs = _context4.sent;
            updatedPosts = _objectSpread(_objectSpread({}, prevPosts), {}, {
              loading: false,
              total: rs.data.total,
              page: rs.data.page,
              data: [].concat(_toConsumableArray(prevPosts.data), _toConsumableArray(rs.data.data))
            });
            context.commit(types.UPDATE_CATE_POSTS, {
              key: key,
              value: updatedPosts
            });
            _context4.next = 18;
            break;
          case 14:
            _context4.prev = 14;
            _context4.t0 = _context4["catch"](6);
            console.log('Error loading posts:', _context4.t0);
            context.commit(types.UPDATE_CATE_POSTS, {
              key: key,
              value: _objectSpread(_objectSpread({}, prevPosts), {}, {
                loading: false
              })
            });
          case 18:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[6, 14]]);
    }));
    function loadCatePosts(_x5) {
      return _loadCatePosts.apply(this, arguments);
    }
    return loadCatePosts;
  }(),
  setCurrentCate: function setCurrentCate(context) {
    var cate = vm.$route.params.cate;
    if (context.getters.getCurrentCate && context.getters.getCurrentCate.code !== cate) {
      vm.$axios.get("/post_cates/".concat(cate)).then(function (rs) {
        context.commit(types.UPDATE_CURRENT_CATE, rs.data);
      });
    }
  },
  callTagPosts: function callTagPosts(context) {
    if (!context.getters.getTagPosts || context.getters.getTagPosts.total < 1) {
      context.dispatch('loadTagPosts');
    }
  },
  loadTagPosts: function () {
    var _loadTagPosts = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(context) {
      var tag, key, posts, params, rs;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            tag = vm.$route.params.tag;
            key = "tag_".concat(tag);
            posts = cloneData(context.getters.getTagPosts);
            posts.loading = true;
            context.commit(types.UPDATE_TAG_POSTS, {
              key: key,
              value: posts
            });
            params = {
              params: {
                tag: tag,
                p: posts.page + 1,
                perPage: posts.perPage
              }
            };
            _context5.next = 8;
            return vm.$axios.get('/posts/search', params);
          case 8:
            rs = _context5.sent;
            posts.loading = false;
            posts.total = rs.data.total;
            posts.page = rs.data.page;
            posts.data = posts.data.concat(rs.data.data);
            context.commit(types.UPDATE_TAG_POSTS, {
              key: key,
              value: posts
            });
          case 14:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    function loadTagPosts(_x6) {
      return _loadTagPosts.apply(this, arguments);
    }
    return loadTagPosts;
  }(),
  callEditorPosts: function callEditorPosts(context) {
    if (!context.getters.getEditorPosts || context.getters.getEditorPosts.total < 1) {
      context.dispatch('loadEditorPosts');
    }
  },
  loadEditorPosts: function () {
    var _loadEditorPosts = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(context) {
      var idx, key, posts, params, rs;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            idx = vm.$route.params.idx;
            key = "editor_".concat(idx);
            posts = cloneData(context.getters.getEditorPosts);
            posts.loading = true;
            context.commit(types.UPDATE_EDITOR_POSTS, {
              key: key,
              value: posts
            });
            params = {
              params: {
                writer: idx,
                p: posts.page + 1,
                perPage: posts.perPage
              }
            };
            _context6.next = 8;
            return vm.$axios.get('/posts/search', params);
          case 8:
            rs = _context6.sent;
            posts.loading = false;
            posts.total = rs.data.total;
            posts.page = rs.data.page;
            posts.data = posts.data.concat(rs.data.data);
            context.commit(types.UPDATE_EDITOR_POSTS, {
              key: key,
              value: posts
            });
          case 14:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    function loadEditorPosts(_x7) {
      return _loadEditorPosts.apply(this, arguments);
    }
    return loadEditorPosts;
  }(),
  setCurrentEditor: function setCurrentEditor(context) {
    var idx = vm.$route.params.idx;
    vm.$axios.get("/members/".concat(idx)).then(function (rs) {
      context.commit(types.UPDATE_CURRENT_EDITOR, rs.data);
    });
  },
  callSearchArticles: function callSearchArticles(context) {
    if (!context.getters.getSearchArticles || context.getters.getSearchArticles.total < 1) {
      context.dispatch('loadSearchArticles');
    }
  },
  loadSearchArticles: function () {
    var _loadSearchArticles = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(context) {
      var keyword, key, posts, params, rs;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            keyword = vm.$route.params.keyword;
            key = "search_articles_".concat(keyword);
            posts = cloneData(context.getters.getSearchArticles);
            posts.loading = true;
            context.commit(types.UPDATE_SEARCH_ARTICLES, {
              key: key,
              value: posts
            });
            params = {
              params: {
                keyword: keyword,
                p: posts.page + 1,
                perPage: posts.perPage
              }
            };
            _context7.next = 8;
            return vm.$axios.get('/posts/search', params);
          case 8:
            rs = _context7.sent;
            posts.loading = false;
            posts.total = rs.data.total;
            posts.page = rs.data.page;
            posts.data = posts.data.concat(rs.data.data);
            context.commit(types.UPDATE_SEARCH_ARTICLES, {
              key: key,
              value: posts
            });
          case 14:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    function loadSearchArticles(_x8) {
      return _loadSearchArticles.apply(this, arguments);
    }
    return loadSearchArticles;
  }(),
  putListOfCalledAPI: function putListOfCalledAPI(context, payload) {
    context.commit(types.PUSH_LIST_OF_CALLED_API, payload);
  },
  setDisplayCateData: function setDisplayCateData(context, payload) {
    context.commit(types.UPDATE_DISPLAY_CATE_DATA, payload);
  },
  setDisplayData: function setDisplayData(context, payload) {
    context.commit(types.UPDATE_DISPLAY_DATA, payload);
  },
  setDisplayPage: function setDisplayPage(context, payload) {
    context.commit(types.UPDATE_DISPLAY_PAGE, payload);
  },
  setToastBannerSmallSize: function setToastBannerSmallSize(context, payload) {
    context.commit(types.CHANGE_SIZE_TOAST_BANNER, payload);
  },
  setOpenShareDialog: function setOpenShareDialog(context, payload) {
    context.commit(types.CHANGE_OPEN_SHARE_DIALOG, payload);
  },
  setOpenFooter1Dialog: function setOpenFooter1Dialog(context, payload) {
    context.commit(types.CHANGE_OPEN_FOOTER1_DIALOG, payload);
  },
  setOpenFooter2Dialog: function setOpenFooter2Dialog(context, payload) {
    context.commit(types.CHANGE_OPEN_FOOTER2_DIALOG, payload);
  },
  setOpenFooter3Dialog: function setOpenFooter3Dialog(context, payload) {
    context.commit(types.CHANGE_OPEN_FOOTER3_DIALOG, payload);
  },
  setOpenFaqDialog: function setOpenFaqDialog(context, payload) {
    context.commit(types.CHANGE_OPEN_FAQ_DIALOG, payload);
  },
  setOpenTeamDialog: function setOpenTeamDialog(context, payload) {
    context.commit(types.CHANGE_OPEN_TEAM_DIALOG, payload);
  },
  setCurrentContentsData: function setCurrentContentsData(context, payload) {
    context.commit(types.UPDATE_CURRENT_CONTENTS_DATA, payload);
  }
};